import { signinRedirect } from "../../auth/userServices";
import { FaSalesforce } from "react-icons/fa";
import { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import "./Login.scss";
import logger from "../../utils/logger";

const Login = () => {
  const navigate = useNavigate();
  const isMockAuth = process.env.REACT_APP_MOCK_AUTH === 'true';

  useEffect(() => {
    if (isMockAuth) {
      // Redirect to caselist immediately when mock auth is enabled
      navigate('/caselist');
    }
  }, [isMockAuth, navigate]);

  // If mock auth is enabled, show loading or redirect immediately
  if (isMockAuth) {
    return (
      <div className="login-container">
        <div className="login-header">
          <h2>netnumber Customer Portal</h2>
          <p>Mock authentication enabled - redirecting...</p>
        </div>
      </div>
    );
  }

  console.log("Test Deployment Change!");

  return (
    <>
      <div className="login-container">
        <div className="login-header">
          <h2>netnumber Customer Portal</h2>
          <p>
            Welcome to the netnumber Customer Portal! Please login through your
            netnumber account
          </p>
        </div>
        <div className="line"></div>
        <button
          className="login-button"
          onClick={() => {
            signinRedirect()
              .then((res: any) => {
                logger.log(res);
              })
              .catch((err: any) => {
                logger.error(err);
              });
          }}
        >
          <FaSalesforce size={"4rem"} color="white" />
          <h1 style={{ color: "white" }}>Login</h1>
        </button>
      </div>
    </>
  );
};

export default Login;
